import type { UserResource } from "@exonn/js-sdk";
import type { StorageKey } from "@exonn/storage";
import { memoryStorageDriver } from "src/storage/memoryStorage.driver.ts";

export const setUserDataCache = <V = any>({
  user,
  key,
  value,
}: {
  user: UserResource;
  key: StorageKey;
  value: V | null;
}) => {
  const key_ = {
    name: `user-data-${user.id}-${key.name}`,
    version: key.version,
  };

  if (value == null && memoryStorageDriver.get<V>(key) != null) {
    memoryStorageDriver.remove(key_);
    return null;
  }
  memoryStorageDriver.set(key_, value);
};
